var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"holdingsPieChart"},[_c('apexchart',{attrs:{"width":_vm.chartWidth,"options":_vm.options,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }